module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0032.png.0400570b.jpg";